export default {
  en: {
    tab: 'Supplier invites',
    info: {
      noInvites: 'No invites found matching the filters.',
    },
    invite: {
      send: 'Send invite',
      cancel: 'Cancel',
      button: 'Invite supplier',
      title: 'Invite {orgName} to Risk Ledger',
      company: 'Company name',
      contact: 'Contact email',
      companyPlaceholder: 'Enter a company name...',
      contactPlaceholder: 'Enter a contact email...',
      success: 'Invite successfully sent to {0}.',
      error: 'There was an error sending the invite. Try again later.',
    },
    form: {
      primerEmail: {
        desc: 'I confirm a {primerEmail} has been sent to this supplier.',
        link: 'Primer email',
      },
    },
    success: {
      invite: 'Invite successfully sent',
      inviteMessage: 'Invite for {0} sent to the address: {1}.',
      request: 'Connection request successfully sent',
      requestMessage: 'You have sent a connection request to {0}.',
      close: 'Close',
      newInvite: 'Invite another supplier',
    },
    suggest: {
      title: 'Is this your supplier?',
      button: 'No, send invite to {name}',
      back: 'Back',
    },
    labels: {
      sentBy: 'Sent by',
      status: 'Status',
    },
    filters: {
      all: 'All',
      pending: 'Pending',
      accepted: 'Accepted',
      expired: 'Expired',
      cancelled: 'Cancelled',
      search: 'Organisation name...',
      dateCreated: 'Date created',
      name: 'Name',
      me: 'Me',
      anyone: 'Anyone',
    },
    list: {
      buttons: {
        resend: 'Resend',
        resent: 'Re-sent',
        viewSupplier: 'View',
        cancel: 'Cancel',
        cancelInvite: 'Yes, cancel invite',
        closeModal: 'No',
        cancelled: 'Cancelled',
      },
      modal: {
        cancelTitle: 'Are you sure you want to cancel the invite for {0}?',
        cancelDescription: 'The links provided in the emails sent to {0} will become invalid.',
      },
      expiresBy: 'Expires on {0}',
      expiredAt: 'Expired at {0}',
      expiresIn: 'Expires {0}',
      expiredAgo: 'Expired {0}',
      cancelledAt: 'Cancelled on {0}',
      acceptedAt: 'Accepted on {0}',
      sentBy: 'Sent by {name} on {date}',
      pending: 'Pending',
      accepted: 'Accepted',
      cancelled: 'Cancelled',
      expired: 'Expired',
      errorCancel: 'Failed to cancel invite. Please try again.',
      errorResend: 'Failed to resend invite. Please try again.',
    },
    buttons: {
      pending: 'Pending invites',
    },
    redeem: {
      titleActive: 'Accept invite from {0}?',
      descriptionActive:
        'This connects you to them and lets them view your Risk Ledger profile. You can decide later by clicking your invite link again.',
      titleAccepted: 'Your invite from {0} has already been accepted.',
      descriptionAccepted:
        "Don't worry! Check your clients list to view their profile. If they aren't there, use the search bar to send them a connection request.",
      titleCancelled: '{0} has cancelled this invite.',
      titleExpired: 'Your invite from {0} has expired.',
      descriptionCancelledOrExpired:
        "Don't worry! Use the search bar to find them and send a connection request.",
      titleUnclaimedMismatch: 'This invite is for a different organisation',
      descriptionUnclaimedMismatch:
        'You’re logged into a different organisation than the one this invite is for. If the invite should be for your current organisation, ask the sender to update the invite. To accept this invite, log out and open the link again.',
      redeem: 'Accept',
      dismiss: 'Do it later',
      ack: 'Got it!',
      getFailed: 'Failed to retrieve invite details.',
      redeemFailed: 'Failed to accept invite.',
      getInviteAgain: 'Try again',
      signOut: 'Sign out',
    },
    csvExport: {
      invites: {
        export: 'Export',
        filename: 'RiskLedger-Invites',
        recipientOrgName: 'Recipient organisation',
        recipientEmail: 'Recipient email',
        sender: 'Sender',
        sentDate: 'Sent date',
        resentDate: 'Re-sent date',
        accepted: 'Accepted',
        acceptedDate: 'Accepted date',
        cancelled: 'Cancelled',
        cancelledDate: 'Cancelled date',
        expired: 'Expired',
        expiryDate: 'Expiry date',
        dateFormat: 'yyyy/MM/dd',
        fetchingCsvInvitesError: 'Failed to fetch CSV invites. Please try again.',
      },
    },
  },
};
